//#region Imports
import {
  allModels,
  ioViewer,
  unfocusAny,
  ioRaycaster,
  viewMode,
  updateRaycasterFromEvent,
  getIoMouse3dDirection,
  getGlobalMesh,
  rotateIntraoralToView,
  upper_measurements,
  lower_measurements,
  upperBox,
  lowerBox,
  intersectTooth,
  intraoralMenu,
  ioPanoMenu,
} from "../IntraoralManager";
import { getDistance } from "../IntraoralDraw";
import IntraoralMeasureControls from "./IntraoralMeasureControls.vue";
import IntraoralMeasurePanel from "./IntraoralMeasurePanel.vue";

import { initToothNumberOptions } from "../number/IntraoralNumberMode";
import {
  saveMeasurements,
  sendCreateMeasurementsRequest,
} from "@/api/intraoralApi";
import swal from "sweetalert";
import { showLoader, hideLoader } from "@/components/controls/Loader.vue";
import { get3Distance } from "../IntraoralDraw";
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from "three.meshline";
import { commonContext } from "./IntraoralArchMode";
// import BoltonMeasureControls from "./BoltonMeasureControls.vue";

//#endregion

//#region Fields

let firstClick = true;
let controlsInitialized = false;
let meshesInitialized = false;
let clickTime = Date.now();
let isMobile = false;
let dragPoint = null;
let clickedTooth = null;
let startTopSumTooth = null;
let endTopSumTooth = null;
let startLowSumTooth = null;
let endLowSumTooth = null;

let allMeshes = null;
let clickDif = 300;

let labelCtxWidth = 100;
let labelCtxHeight = 50;
let labelCtx = null;

let molarLines = [];

const measureContext = {
  isActive: false,
  distance: 0,
  sumDistance: 0,
  totalDistance: 0,
  premolarDistance: 0,
  firstSixDistance: 0,
  twelveDistance: 0,
  isWhite: false,
  whiteColor: "#ffffff",
  blueColor: "#007bff",
  showTeethLines: true,
  showTeethNumbers: true,
  showCrossLines: true,
  showPanel: true
};

let ioMeasureMenu = null;
let ioMeasureStartSumBtn = null;
let ioMeasureEndSumBtn = null;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const molarPairs = [
  [14, 24],
  [15, 25],
  [16, 26],
  [17, 27],
  [18, 28],
  [34, 44],
  [35, 45],
  [36, 46],
  [37, 47],
  [38, 48],
];
const molarMap = {};

let lowerStart6Model = null;
let lowerEnd6Model = null;

let upperStart6Model = null;
let upperEnd6Model = null;

//#endregion

// async function getMeasurements() {
//   let upperMeasureJson = `${vueApp.dicomUrl}/crown-segmentation-standalone-upper/`;
//   fetch();
// }

async function switchMeasureMode(isMeasure) {
  console.log("switchMeasureMode", isMeasure);
  if (isMeasure) {
    await enterMeasureMode(true);
  } else if (viewMode.isMeasureMode) {
    viewMode.isMeasureMode = measureContext.isActive = false;
    leaveMeasureMode();
  }
}

async function enterMeasureMode(showControls) {
  let measurements = viewMode.isUpper ? upper_measurements : lower_measurements;
  if (!measurements) {
    if (viewMode.isPostprocessing) {
      swal({
        text: "Please wait for case postprocessing to complete.",
      });
    } else {
      swal({
        text: "Teeth measurements not found. Would you like to generate them?",
        buttons: {
          yes: { text: "Yes", value: true },
          no: { text: "No", value: false },
        },
      }).then(async (postprocess) => {
        if (postprocess) {
          viewMode.isPostprocessing = true;
          sendCreateMeasurementsRequest();
        }
      });
    }
    return false;
  }

  viewMode.isMeasureMode = measureContext.isActive = true;

  initializeIoMeasure();

  if (ioMeasureMenu) ioMeasureMenu.style.display = "none";
  if (intraoralMenu) intraoralMenu.style.display = "none";
  if (ioPanoMenu) ioPanoMenu.style.display = "none";

  await unfocusAny();
  await rotateIntraoralToView(2);
  await delay(200);

  // if (viewMode.isUpper) rotateIntraoralToView(2);
  // else rotateIntraoralToView(1);

  viewMode.isMeasureMode = true;
  measureContext.isWhite = false; //vueApp.isWhite;
  measureContext.whiteColor = vueApp.whiteColor;
  measureContext.blueColor = vueApp.blueColor;
  measureContext.sumDistance =
    measureContext.totalDistance =
    measureContext.premolarDistance =
    measureContext.firstSixDistance =
    measureContext.twelveDistance =
      0;

  await initToothNumberOptions();
  initMeasureMeshes();

  updateMolarLines();

  for (const model of allModels
    .filter((m) => m.measurePoints && !m.isDeleted)
    .sort((a, b) => b.number - a.number)) {
    // ioViewer.set_opacity(model.id, 1); // 0.6 1
    model.measureLabel = drawMeasureLabel(model);
    updateMeasureVisibility(model);

    if (model.isUpper == viewMode.isUpper && model.measureDistance) {
      measureContext.totalDistance += model.measureDistance;
      if (model.number % 10 < 4) {
        measureContext.firstSixDistance += model.measureDistance;
      }
      if (model.number % 10 < 6) {
        measureContext.premolarDistance += model.measureDistance;
      }
      if (model.number % 10 < 7) {
        measureContext.twelveDistance += model.measureDistance;
      }
      if (model.inMeasureSum) {
        measureContext.sumDistance += +model.measureDistance.toFixed(2);
      }
    }
  }

  isMobile = mobileAndTabletCheck();
  clickDif = isMobile ? 400 : 200;
  allMeshes = [getGlobalMesh()];
  firstClick = true;

  if (showControls) {
    document.getElementById("ioMeasureControls").style.display = "block";
    document.getElementById("ioMeasurePanel").style.display = "block";
    measureContext.showPanel = true;
    $(`#intraoralMeasurePanel`).addClass("show");
  }
}

async function leaveMeasureMode(saveChanges) {
  console.log("leaveMeasureMode", saveChanges);

  if (ioMeasureMenu) ioMeasureMenu.style.display = "none";

  let jsonObj = viewMode.isUpper ? upper_measurements : lower_measurements;
  if (jsonObj) {
    let measureObj = jsonObj.teeth_measurements;
    allModels.forEach((model) => {
      // ioViewer.set_opacity(model.id, viewMode.opacity);
      if (model.measureMeshes) {
        model.measurePoint1 = model.firstMeasurePoint.position;
        model.measurePoint2 = model.secondMeasurePoint.position;

        model.measurePoints = [
          [model.measurePoint1.x, model.measurePoint1.y, model.measurePoint1.z],
          [model.measurePoint2.x, model.measurePoint2.y, model.measurePoint2.z],
        ];

        let snumber = `${model.number}`;
        if (!measureObj[snumber]) {
          measureObj[snumber] = {};
        }

        measureObj[snumber].width = model.measureDistance;
        measureObj[snumber].points = model.measurePoints;
      }
    });
  }

  if (saveChanges) {
    showLoader(`Saving data... Please wait`, "", true, 0.7);
    let result = await saveMeasurements(jsonObj, viewMode.isUpper);
    hideLoader();
    swal(result ? "Measurements saved" : "Failed to save measurements");
  }

  allModels.forEach((model) => {
    if (model.measureMeshes) {
      for (const mesh of model.measureMeshes) {
        mesh.visible = false;
        if (mesh.style) {
          mesh.style.display = "none";
        }
      }
    }
  });

  for (const line of molarLines) {
    line.visible = false;
    line.measureLabel.style.display = "none";
  }

  viewMode.isMeasureMode = false;

  measureContext.distance = 0;
  let ioMeasureControls = document.getElementById("ioMeasureControls");
  if (ioMeasureControls) ioMeasureControls.style.display = "none";
  let boltonControls = document.getElementById("ioMeasurePanel");
  if (boltonControls) boltonControls.style.display = "none";
}

function initMeasureMeshes() {
  if (!meshesInitialized) {
    meshesInitialized = true;

    let measureModels = allModels
      .filter((m) => m.measurePoints && !m.isDeleted)
      .sort((a, b) => b.number - a.number);
    commonContext.hasUpper = !!measureModels.find((m) => m.isUpper);
    commonContext.hasLower = !!measureModels.find((m) => !m.isUpper);

    for (const model of measureModels) {
      // ioViewer.set_opacity(model.id, 1); // 0.6 1
      if (!model.measureMeshes) {
        // let mesh = model.mesh; // ioViewer.scene;
        // let point1 = getNearestPoint(mesh, model.measurePoint1);
        // let point2 = getNearestPoint(mesh, model.measurePoint2);
        let point1 = model.measurePoint1;
        let point2 = model.measurePoint2;
        model.measureLine = drawMeasureLine(model, point1, point2);
        model.firstMeasurePoint = drawMeasurePoint(
          point1,
          ioViewer.scene,
          model.color,
        );
        model.secondMeasurePoint = drawMeasurePoint(
          point2,
          ioViewer.scene,
          model.color,
        );
        model.secondMeasurePoint.model = model;
        model.firstMeasurePoint.model = model;

        model.measureDistance = getDistance(
          model.firstMeasurePoint.position,
          model.secondMeasurePoint.position,
        ); //.toFixed(2);

        if (model.isUpper) {
          commonContext.upperTeethAllSum += model.measureDistance;
          if (model.number % 10 < 4) {
            commonContext.upperTeethFirstSixSum += model.measureDistance;
          }
          if (model.number % 10 < 6) {
            commonContext.upperTeethPremolarSum += model.measureDistance;
          }
          if (model.number % 10 < 7) {
            commonContext.upperTeethTwelveSum += model.measureDistance;
          }
        } else {
          commonContext.lowerTeethAllSum += model.measureDistance;
          if (model.number % 10 < 4) {
            commonContext.lowerTeethFirstSixSum += model.measureDistance;
          }
          if (model.number % 10 < 6) {
            commonContext.lowerTeethPremolarSum += model.measureDistance;
          }
          if (model.number % 10 < 7) {
            commonContext.lowerTeethTwelveSum += model.measureDistance;
          }
        }

        model.measureLabel = drawMeasureLabel(model);

        model.measureMeshes = [
          model.firstMeasurePoint,
          model.secondMeasurePoint,
          model.measureLine,
          model.measureLabel,
        ];
      }
    }

    lowerStart6Model = measureModels.filter(
      (m) => m.number >= 31 && m.number <= 33,
    )[0];
    if (lowerStart6Model) {
      commonContext.lowerStart6 = lowerStart6Model.measurePoint1;
    }

    lowerEnd6Model = measureModels.filter(
      (m) => m.number >= 41 && m.number <= 43,
    )[0];
    if (lowerEnd6Model) {
      commonContext.lowerEnd6 = lowerEnd6Model.measurePoint2;
    }

    upperStart6Model = measureModels.filter(
      (m) => m.number >= 11 && m.number <= 13,
    )[0];
    if (upperStart6Model) {
      commonContext.upperStart6 = upperStart6Model.measurePoint1;
    }

    upperEnd6Model = measureModels.filter(
      (m) => m.number >= 21 && m.number <= 23,
    )[0];
    if (upperEnd6Model) {
      commonContext.upperEnd6 = upperEnd6Model.measurePoint2;
    }

    console.log(
      "measureModels",
      lowerStart6Model,
      lowerEnd6Model,
      upperStart6Model,
      upperEnd6Model,
    );
  }
}

function updateMolarLines() {
  for (const line of molarLines) {
    line.visible = false;
    line.measureLabel.style.display = "none";
    line.molar0 = undefined;
    line.molar1 = undefined;
  }

  for (const pair of molarPairs) {
    let number0 = pair[0];
    let number1 = pair[1];
    let molar0 = allModels.find((x) => +x.number === number0);
    let molar1 = allModels.find((x) => +x.number === number1);
    if (molar0 && molar1) {
      console.log("molars", number0, number1);
      let molarLine = drawMolarLine(molar0, molar1);
      if (molarLine) {
        molarLine.molar0 = molar0;
        molarLine.molar1 = molar1;
        if (!molarLines.includes(molarLine)) {
          ioViewer.scene.add(molarLine);
          molarLines.push(molarLine);
        }
      }
    }
  }

  for (const line of molarLines) {
    line.visible =
      !!line.molar0 &&
      !!line.molar1 &&
      line.isUpper === viewMode.isUpper &&
      measureContext.showCrossLines;
    line.measureLabel.style.display = line.visible ? "block" : "none";
  }
}

// Controls
function initializeIoMeasure() {
  if (!controlsInitialized) {
    let ctrls = [IntraoralMeasureControls, IntraoralMeasurePanel];
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: {
          editContext: measureContext,
          commonContext: commonContext,
        },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("intraoralViewer").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });

    initMeasureMenu();

    controlsInitialized = true;

    ioViewer.controls.addEventListener("change", onCameraChangeForMeasures);

    const canvas = document.createElement("canvas");
    canvas.width = labelCtxWidth;
    canvas.height = labelCtxHeight;
    labelCtx = canvas.getContext("2d");
    labelCtx.font = "22px serif";
    labelCtx.scale(-1, 1);
  }
}

function initMeasureMenu() {
  ioMeasureMenu = document.getElementById("iomeasure-menu");
  document.getElementById("intraoralViewer").appendChild(ioMeasureMenu);

  ioMeasureStartSumBtn = document.getElementById("iomeasure-start-sum-btn");
  ioMeasureStartSumBtn.addEventListener("click", () => {
    console.log("iomeasure start sum click");
    ioMeasureMenu.style.display = "none";
    if (clickedTooth) {
      // clickedTooth.inMeasureSum = true;
      // drawMeasureLabel(clickedTooth, true);
      if (viewMode.isUpper) {
        startTopSumTooth = clickedTooth;
      } else {
        startLowSumTooth = clickedTooth;
      }
      calculateSumTeethDistance();
    }
    clickedTooth = null;
  });

  ioMeasureEndSumBtn = document.getElementById("iomeasure-end-sum-btn");
  ioMeasureEndSumBtn.addEventListener("click", () => {
    console.log("iomeasure end sum click");
    ioMeasureMenu.style.display = "none";
    if (clickedTooth) {
      // clickedTooth.inMeasureSum = false;
      // drawMeasureLabel(clickedTooth, true);
      if (viewMode.isUpper) {
        endTopSumTooth = clickedTooth;
      } else {
        endLowSumTooth = clickedTooth;
      }
      calculateSumTeethDistance();
    }
    clickedTooth = null;
  });
}

function updateMeasureVisibility(model) {
  if (model && model.measureMeshes) {
    for (const mesh of model.measureMeshes) {
      mesh.visible = model.isUpper == viewMode.isUpper;
    }
    model.measureLabel.style.display =
      model.isUpper == viewMode.isUpper && measureContext.showTeethNumbers
        ? "block"
        : "none";
    // console.log(model.number, model.measureLabel.display);
    model.measureLine.visible =
      model.isUpper == viewMode.isUpper && measureContext.showTeethLines;
  }
}

function calculateSumTeethDistance() {
  let startSumTooth = viewMode.isUpper ? startTopSumTooth : startLowSumTooth;
  let endSumTooth = viewMode.isUpper ? endTopSumTooth : endLowSumTooth;

  if (startSumTooth && endSumTooth) {
    let start = Math.min(startSumTooth.number, endSumTooth.number);
    let end = Math.max(startSumTooth.number, endSumTooth.number);
    let start0 = String(start)[0];
    let end0 = String(end)[0];

    let numbers = [];
    if (start0 == end0) {
      numbers = range(start, end);
    } else {
      numbers = range(+`${start0}1`, start).concat(range(+`${end0}1`, end));
    }

    measureContext.sumDistance = 0;
    for (const model of allModels.filter(
      (m) => m.measurePoints && !m.isDeleted,
    )) {
      if (model.isUpper == viewMode.isUpper && model.measureDistance) {
        model.inMeasureSum = numbers.includes(model.number);
        drawMeasureLabel(model, true);
        if (model.inMeasureSum) {
          measureContext.sumDistance += +model.measureDistance.toFixed(2);
        }
      }
    }
  }
}

function range(start, end) {
  const result = [];
  for (let i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
}

function addMeasureClick(model) {
  console.log("addMeasureClick", model);
  let mesh = model.mainMesh;
  let meshBox = getMeshBox(mesh);
  let geometry = mesh.geometry;
  let position = mesh.position;

  let minX = Infinity;
  let maxX = -Infinity;

  let minY = Infinity;
  let maxY = -Infinity;

  let minPoint = new THREE.Vector3(meshBox.min.x, meshBox.min.y, meshBox.max.z);
  let maxPoint = new THREE.Vector3(meshBox.max.x, meshBox.max.y, meshBox.max.z);

  const pos = geometry.getAttribute("position");
  for (let i = 0; i < pos.count; i++) {
    const x = pos.getX(i);
    const y = pos.getY(i);
    const z = pos.getZ(i);
    if (x < minX) {
      // || y > maxY
      minX = x;
      // if (y > maxY) maxY = y;
      minPoint.set(x, y, z);
    } else if (x > maxX) {
      maxX = x;
      // if (y < minY) minY = y;
      maxPoint.set(x, y, z);
    }
  }
  model.measurePoints = [maxPoint, minPoint];
  model.measurePoint1 = maxPoint;
  model.measurePoint2 = minPoint;

  model.measureLine = drawMeasureLine(
    model,
    model.measurePoint1,
    model.measurePoint2,
  );

  model.firstMeasurePoint = drawMeasurePoint(
    model.measurePoint1,
    ioViewer.scene,
    model.color,
    // 0x0000ff,
  );
  model.secondMeasurePoint = drawMeasurePoint(
    model.measurePoint2,
    ioViewer.scene,
    model.color,
    // 0x00ff00,
  );

  model.secondMeasurePoint.model = model;
  model.firstMeasurePoint.model = model;

  model.measureDistance = getDistance(
    model.firstMeasurePoint.position,
    model.secondMeasurePoint.position,
  ); //.toFixed(2);

  model.measureLabel = drawMeasureLabel(model, true);

  model.measureMeshes = [
    model.firstMeasurePoint,
    model.secondMeasurePoint,
    model.measureLine,
    model.measureLabel,
  ];
  updateMeasureVisibility(model);

  if (model.isUpper == viewMode.isUpper && model.measureDistance) {
    measureContext.totalDistance += model.measureDistance;
    if (model.number % 10 < 4) {
      measureContext.firstSixDistance += model.measureDistance;
    }
    if (model.number % 10 < 6) {
      measureContext.premolarDistance += model.measureDistance;
    }
    if (model.number % 10 < 7) {
      measureContext.twelveDistance += model.measureDistance;
    }
    if (viewMode.isUpper) {
      commonContext.upperTeethTwelveSum = +measureContext.twelveDistance;
      commonContext.upperTeethFirstSixSum = +measureContext.firstSixDistance;
      commonContext.upperTeethPremolarSum = +measureContext.premolarDistance;
      commonContext.upperTeethAllSum = +measureContext.totalDistance;
    } else {
      commonContext.lowerTeethTwelveSum = +measureContext.twelveDistance;
      commonContext.lowerTeethFirstSixSum = +measureContext.firstSixDistance;
      commonContext.lowerTeethPremolarSum = +measureContext.premolarDistance;
      commonContext.lowerTeethAllSum = +measureContext.totalDistance;
    }
  }
}

function getMeshBox(mesh) {
  if (mesh) {
    const position = mesh.position;
    const geometry = mesh.geometry;
    geometry.computeBoundingBox();
    const meshBox = offsetBox(
      geometry.boundingBox,
      position.x,
      position.y,
      position.z,
    );
    return meshBox;
  }
}

let lastTicks = Date.now();
function onCameraChangeForMeasures(controls) {
  const currentTicks = Date.now();
  if (measureContext.isActive && currentTicks - lastTicks > 10) {
    lastTicks = currentTicks;
    for (const model of allModels) {
      if (model.measureLabel) {
        drawMeasureLabel(model);
      }
    }

    for (const line of molarLines) {
      drawMolarLabel(line);
    }
  }
}

function measureMouseClick(event) {
  // console.log("measureMouseClick");
  // if (dragPoint) {
  //   dragPoint = null;
  //   return;
  // }
  // if (ioMeasureMenu) ioMeasureMenu.style.display = "none";
}

function measureMouseDown(event) {
  if (ioMeasureMenu) ioMeasureMenu.style.display = "none";
  if (intraoralMenu) intraoralMenu.style.display = "none";
  if (ioPanoMenu) ioPanoMenu.style.display = "none";

  const now = Date.now();
  const millis = now - clickTime;
  clickedTooth = dragPoint = null;
  if (millis > clickDif && firstClick) {
    updateRaycasterFromEvent(event);

    if (event.button === 2) {
      clickedTooth = intersectTooth();

      if (clickedTooth) {
        ioMeasureMenu.style.display = "initial";
        ioMeasureMenu.style.left = event.offsetX + 1 + "px";
        ioMeasureMenu.style.top = event.offsetY + 1 + "px";
        // ioMeasureStartSumBtn.style.display = !clickedTooth.inMeasureSum
        //   ? "initial"
        //   : "none";
        // ioMeasureEndSumBtn.style.display = clickedTooth.inMeasureSum
        //   ? "initial"
        //   : "none";
      }
    } else {
      dragPoint = intersectDragPoint();
    }

    if (dragPoint || clickedTooth) {
      // let point = intersectMesh(dragPoint.model.mesh);
      // console.log("mesh point", point);
      if (event.preventDefault) event.preventDefault();
      ioViewer.controls.enabled = false;
    } else {
      ioViewer.controls.enabled = true;
    }
  }
}

function measureMouseMove(event) {
  if (dragPoint) {
    updateRaycasterFromEvent(event);
    let point = intersectMesh(dragPoint.model.mesh);
    if (point) {
      dragPoint.position.copy(point);
      let model = dragPoint.model;
      model.measureLine = drawMeasureLine(
        model,
        model.firstMeasurePoint.position,
        model.secondMeasurePoint.position,
        model.measureLine,
      );
      measureContext.distance = getDistance(
        model.firstMeasurePoint.position,
        model.secondMeasurePoint.position,
      ).toFixed(2);
    }
  }
}

function measureMouseUp(event) {
  if (event.button !== 2) {
    if (dragPoint) {
      let model = dragPoint.model;
      model.measureDistance = getDistance(
        model.firstMeasurePoint.position,
        model.secondMeasurePoint.position,
      ); //.toFixed(2);

      drawMeasureLabel(model, true);
    }
    measureContext.totalDistance =
      measureContext.premolarDistance =
      measureContext.firstSixDistance =
      measureContext.twelveDistance =
      measureContext.sumDistance =
        0;
    for (const model of allModels) {
      if (model.isUpper == viewMode.isUpper && model.measureDistance) {
        measureContext.totalDistance += model.measureDistance;
        if (model.number % 10 < 4) {
          measureContext.firstSixDistance += model.measureDistance;
        }
        if (model.number % 10 < 6) {
          measureContext.premolarDistance += model.measureDistance;
        }
        if (model.number % 10 < 7) {
          measureContext.twelveDistance += model.measureDistance;
        }
        if (model.inMeasureSum) {
          measureContext.sumDistance += +model.measureDistance.toFixed(2);
        }
      }
    }

    if (viewMode.isUpper) {
      commonContext.upperTeethTwelveSum = +measureContext.twelveDistance;
      commonContext.upperTeethFirstSixSum = +measureContext.firstSixDistance;
      commonContext.upperTeethPremolarSum = +measureContext.premolarDistance;
      commonContext.upperTeethAllSum = +measureContext.totalDistance;
    } else {
      commonContext.lowerTeethTwelveSum = +measureContext.twelveDistance;
      commonContext.lowerTeethFirstSixSum = +measureContext.firstSixDistance;
      commonContext.lowerTeethPremolarSum = +measureContext.premolarDistance;
      commonContext.lowerTeethAllSum = +measureContext.totalDistance;
    }

    if (lowerStart6Model) {
      commonContext.lowerStart6 = lowerStart6Model.measurePoint1;
    }
    if (lowerEnd6Model) {
      commonContext.lowerEnd6 = lowerEnd6Model.measurePoint2;
    }
    if (upperStart6Model) {
      commonContext.upperStart6 = upperStart6Model.measurePoint1;
    }
    if (upperEnd6Model) {
      commonContext.upperEnd6 = upperEnd6Model.measurePoint2;
    }
  }

  dragPoint = null;
  ioViewer.controls.enabled = true;
}

function intersectScene() {
  let point = null;
  allMeshes = [getGlobalMesh()];
  let intersects = ioRaycaster.intersectObjects(allMeshes);
  if (intersects.length > 0) {
    // let item = null;
    intersects.find((intersect) => {
      if (intersect.object.visible) {
        point = intersect.point;
        // item = vueApp.getItemByMeshUuid(intersect.object.uuid);
        // if (item !== null) {
        //  point = intersect.point;
        // }
      }

      return point != null;
    });
  }

  // if (!point) {
  //   intersects = ioRaycaster.intersectObject(ioPlane);
  //   if (intersects.length > 0) {
  //     point = intersects[0].point;
  //   }
  // }
  return point;
}

function intersectMesh(mesh) {
  let point = null;
  if (mesh) {
    let intersects = ioRaycaster.intersectObject(mesh);
    if (intersects.length > 0) {
      point = intersects[0].point;
    }
  }
  return point;
}

function intersectDragPoint() {
  let point = null;
  let allPoints = [];
  for (const model of allModels) {
    if (model.isUpper == viewMode.isUpper && model.measureMeshes) {
      allPoints.push(model.firstMeasurePoint);
      allPoints.push(model.secondMeasurePoint);
    }
  }
  let intersects = ioRaycaster.intersectObjects(allPoints);
  if (intersects.length > 0) {
    // let item = null;
    intersects.find((intersect) => {
      if (intersect.object.visible) {
        point = intersect.object;
      }
      return point != null;
    });
  }
  return point;
}

function drawMeasurePoint(point, scene, color, radius) {
  if (point) {
    if (!color) {
      color = 0x0000ff;
    }
    if (!radius) {
      radius = 0.5;
    }
    let material1 = new THREE.MeshPhongMaterial({
      color: color,
      flatShading: false,
      specular: 0x0f0f0f, //0x050505, 0xffffff 0x0f0f0f
      shininess: 200,
      transparent: true,
      side: 2,
      opacity: 0.9,
      // depthTest: false,
      // depthWrite: false,
      polygonOffset: true,
    });
    // material1.polygonOffsetUnit = 1;
    // material1.polygonOffsetFactor = 1;

    const mesh1 = new THREE.Mesh(
      new THREE.SphereBufferGeometry(radius, 32, 32),
      material1,
    );
    mesh1.renderOrder = 9009;
    scene.add(mesh1);
    mesh1.position.set(point.x, point.y, point.z);
    mesh1.visible = false;

    let material2 = new THREE.MeshPhongMaterial({
      color: 0x0000ff,
      flatShading: false,
      specular: 0x0f0f0f, //0x050505, 0xffffff 0x0f0f0f
      shininess: 200,
      transparent: true,
      side: 2,
      depthTest: false,
      depthWrite: false,
      polygonOffset: true,
    });
    material2.polygonOffsetUnit = 1;
    material2.polygonOffsetFactor = 1;
    const mesh2 = new THREE.Mesh(
      new THREE.SphereBufferGeometry(radius / 5, 32, 32),
      material2,
    );
    mesh2.renderOrder = 9909;
    mesh1.add(mesh2);

    return mesh1;
  }
}

function drawMeasureLine(model, point1, point2, existed) {
  // let color = "#" + invertHex(model.color.substr(1));
  let radius = 0.05;
  let vec = point2.clone();
  vec.sub(point1);
  let h = vec.length();
  vec.normalize();
  let quaternion = new THREE.Quaternion();
  quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), vec);
  let geometry = new THREE.CylinderGeometry(radius, radius, h, 32);
  geometry.translate(0, h / 2, 0);

  let cylinder = null;
  if (existed) {
    existed.geometry = geometry;
    cylinder = existed;
    existed.quaternion.identity();
  } else {
    let material = new THREE.MeshBasicMaterial({
      color: 0xff0000, // color, //0xff9900,  0xff0000
      transparent: true,
      side: 2,
      depthTest: false,
      depthWrite: false,
      polygonOffset: true,
    }); //, opacity: 0.2, transparent: true });
    material.polygonOffsetUnit = 1;
    material.polygonOffsetFactor = 1;
    cylinder = new THREE.Mesh(geometry, material);
    cylinder.renderOrder = 9008;
    cylinder.visible = false;
    // cylinder.onBeforeRender = function (renderer) {
    //   renderer.clearDepth();
    // };
    ioViewer.scene.add(cylinder);
  }

  cylinder.applyQuaternion(quaternion);
  cylinder.position.copy(point1);
  return cylinder;
}

function drawMolarLine(molar0, molar1) {
  if (!molar0 || !molar1 || molar0 === molar1) return;

  let molarMesh0 = molar0.mesh;
  let molarMesh1 = molar1.mesh;

  let color = 0xffff00; //0xff0000; 0x007bff;
  let radius = 0.2; //0xff0000;

  let box0 = offsetBox(molarMesh0.geometry.boundingBox);
  let box1 = offsetBox(molarMesh1.geometry.boundingBox);

  let point1 = box0.center;
  let point2 = box1.center;
  let measureMolarZ = Math.max(box0.max.z, box1.max.z);
  //(point1.z + point2.z) / 2;
  point1 = new THREE.Vector3(point1.x, point1.y, measureMolarZ);
  point2 = new THREE.Vector3(point2.x, point2.y, measureMolarZ);

  let points = [];
  points.push(point1.x, point1.y, point1.z);
  points.push(point2.x, point2.y, point2.z);

  const lineX = new MeshLine();
  lineX.setPoints(points);

  let line = molarMap[+molar0.number]; //molarMesh0.measureMolarLine;
  if (!line) {
    const material = new MeshLineMaterial({
      color: color,
      lineWidth: radius,
      transparent: true,
      side: 2,
      // depthTest: false,
      // depthWrite: false,
      polygonOffset: true,
    });
    material.polygonOffsetUnit = 1;
    material.polygonOffsetFactor = 1;

    line = new THREE.Mesh(lineX.geometry, material);
    line.renderOrder = 9997;
    line.isUpper = molar0.isUpper;
    molarMap[+molar0.number] = line;
  } else {
    let temp = line.geometry;
    line.geometry = lineX.geometry;
    temp.dispose();
  }

  line.point1 = point1;
  line.point2 = point2;
  line.textPoint = new THREE.Vector3(
    (point1.x + point2.x) / 2,
    (point1.y + point2.y) / 2 + 0.5,
    measureMolarZ,
  );
  line.length = +point1.distanceTo(point2).toFixed(2);
  line.color = "#FFFF00";
  line.measureLabel = drawMolarLabel(line);
  return line;
}

// invertHex("00FF00"); // Returns FF00FF
function invertHex(hex) {
  return (Number(`0x1${hex}`) ^ 0xffffff).toString(16).substr(1).toUpperCase();
}

function drawMeasureLabel(model, updateText) {
  let canvasHalfWidth = ioViewer.renderer.domElement.offsetWidth / 2;
  let canvasHalfHeight = ioViewer.renderer.domElement.offsetHeight / 2;
  let mesh = model.mesh;
  // let mesh = ioViewer.get_model_mesh(model.id);

  let objectCenter = mesh.textPoint;
  let centerPosition = new THREE.Vector3(
    objectCenter.x,
    objectCenter.y,
    objectCenter.z,
  );
  centerPosition = centerPosition.project(ioViewer.camera);
  centerPosition.x = centerPosition.x * canvasHalfWidth + canvasHalfWidth;
  centerPosition.y = -(centerPosition.y * canvasHalfHeight) + canvasHalfHeight;

  let measureLabel = model.measureLabel;
  if (!measureLabel) {
    measureLabel = document.createElement("div");
    measureLabel.color = `${model.color}`;
    measureLabel.style.color = `${model.color}`;
    measureLabel.style.border = `2px solid ${model.color}`;
    measureLabel.style.position = "absolute";
    // measureLabel.style.zIndex = "9999";
    measureLabel.style.width = "auto";
    measureLabel.style.height = "auto";
    measureLabel.style.padding = "2px";
    measureLabel.style.pointerEvents = "none";
    // measureLabel.style.opacity = "0.5";
    measureLabel.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    measureLabel.style.display = "none";
    measureLabel.style.maxWidth = "90px";
    measureLabel.textContent = `${model.measureDistance.toFixed(2)} mm`;

    document.getElementById("intraoralContainer").appendChild(measureLabel);
  }

  if (updateText) {
    measureLabel.textContent = `${model.measureDistance.toFixed(2)} mm`;
    if (model.inMeasureSum) {
      measureLabel.textContent += " (in sum)";
    }
  }

  measureLabel.style.left = `${centerPosition.x - 35}px`;
  measureLabel.style.top = `${centerPosition.y}px`;
  return measureLabel;
}

function drawMolarLabel(molarLine, updateText) {
  let canvasHalfWidth = ioViewer.renderer.domElement.offsetWidth / 2;
  let canvasHalfHeight = ioViewer.renderer.domElement.offsetHeight / 2;

  let objectCenter = molarLine.textPoint;
  let centerPosition = new THREE.Vector3(
    objectCenter.x,
    objectCenter.y,
    objectCenter.z,
  );
  centerPosition = centerPosition.project(ioViewer.camera);
  centerPosition.x = centerPosition.x * canvasHalfWidth + canvasHalfWidth;
  centerPosition.y = -(centerPosition.y * canvasHalfHeight) + canvasHalfHeight;

  let measureLabel = molarLine.measureLabel;
  if (!measureLabel) {
    measureLabel = document.createElement("div");
    measureLabel.color = `${molarLine.color}`;
    measureLabel.style.color = `${molarLine.color}`;
    measureLabel.style.border = `2px solid ${molarLine.color}`;
    measureLabel.style.position = "absolute";
    // measureLabel.style.zIndex = "9999";
    measureLabel.style.width = "auto";
    measureLabel.style.height = "auto";
    measureLabel.style.padding = "2px";
    measureLabel.style.pointerEvents = "none";
    // measureLabel.style.opacity = "0.5";
    measureLabel.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    measureLabel.style.display = "none";
    measureLabel.style.maxWidth = "100px";
    measureLabel.textContent = `${molarLine.length.toFixed(2)} mm`;
    document.getElementById("intraoralContainer").appendChild(measureLabel);
  }

  if (updateText) {
    measureLabel.textContent = `${molarLine.length.toFixed(2)} mm`;
  }

  measureLabel.style.left = `${centerPosition.x - 35}px`;
  measureLabel.style.top = `${centerPosition.y}px`;
  return measureLabel;
}

function switchShowTeethLines(value) {
  measureContext.showTeethLines = value;
  for (const model of allModels
    .filter((m) => m.measurePoints && !m.isDeleted)
    .sort((a, b) => b.number - a.number)) {
    if (model.measureMeshes) {
      model.measureLine.visible =
        model.isUpper == viewMode.isUpper && measureContext.showTeethLines;
    }
  }
}

function switchShowTeethNumbers(value) {
  measureContext.showTeethNumbers = value;
  for (const model of allModels
    .filter((m) => m.measurePoints && !m.isDeleted)
    .sort((a, b) => b.number - a.number)) {
    updateMeasureVisibility(model);
  }
}

function switchShowCrossLines(value) {
  measureContext.showCrossLines = value;
  for (const line of molarLines) {
    line.visible =
      !!line.molar0 &&
      !!line.molar1 &&
      line.isUpper === viewMode.isUpper &&
      measureContext.showCrossLines;
    line.measureLabel.style.display = line.visible ? "block" : "none";
  }
}

function getNearestPoint(mesh, point) {
  let minDistance = Infinity;
  let point1 = null;
  let x2 = point.x;
  let y2 = point.y;
  let z2 = point.z;
  const pos1 = mesh.geometry.getAttribute("position");
  for (let i = 0; i < pos1.count; i++) {
    const x1 = pos1.getX(i);
    const y1 = pos1.getY(i);
    const z1 = pos1.getZ(i);
    let dist = get3Distance(x1, y1, z1, x2, y2, z2);
    if (dist < minDistance) {
      minDistance = dist;
      point1 = new THREE.Vector3(x1, y1, z1);
    }
  }
  return point1;
}

export {
  molarLines,
  initializeIoMeasure,
  switchMeasureMode,
  enterMeasureMode,
  leaveMeasureMode,
  measureMouseClick,
  measureMouseMove,
  measureMouseUp,
  measureMouseDown,
  addMeasureClick,
  initMeasureMeshes,
  switchShowTeethLines,
  switchShowTeethNumbers,
  switchShowCrossLines,
};
